import { useEffect, useState } from "react";
import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { SmartImage } from "@/components/SmartImage";

// Splash / preload premium ROTY FOOD. Layer vizual izolat afișat înaintea meniului.
// Nu modifică meniul existent — doar un overlay full-screen la intrarea pe pagină.
export const SplashScreen = ({ onDone }) => {
  const [show, setShow] = useState(true);
  const reduce = useReducedMotion();

  useEffect(() => {
    const t = setTimeout(() => setShow(false), reduce ? 900 : 1300);
    return () => clearTimeout(t);
  }, [reduce]);

  const logoAnim = reduce
    ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 } }
    : {
        initial: { opacity: 0, scale: 0.92 },
        animate: { opacity: 1, scale: 1 },
        transition: { delay: 0.05, duration: 0.7, ease: [0.22, 1, 0.36, 1] },
      };
  const textAnim = reduce
    ? { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.3 } }
    : {
        initial: { opacity: 0, y: 6 },
        animate: { opacity: 1, y: 0 },
        transition: { delay: 0.45, duration: 0.5, ease: "easeOut" },
      };

  return (
    <AnimatePresence onExitComplete={onDone}>
      {show ? (
        <motion.div
          key="roty-splash"
          data-testid="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: reduce ? 0.2 : 0.45, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden px-6"
          style={{ backgroundColor: "#140b09" }}
        >
          {/* glow subtil de brand în spatele logo-ului */}
          <div
            aria-hidden
            className="pointer-events-none absolute h-[320px] w-[320px] rounded-full blur-[90px]"
            style={{
              background:
                "radial-gradient(circle, rgba(200,16,46,0.26) 0%, rgba(226,160,19,0.10) 45%, transparent 70%)",
            }}
          />

          <div className="relative flex flex-col items-center">
            {/* Logo existent — reveal elegant */}
            <motion.div {...logoAnim}>
              <SmartImage
                base="logo-splash"
                alt="ROTY FOOD"
                width={116}
                height={128}
                widths={[200, 300, 400]}
                sizes="116px"
                eager
                className="h-28 w-auto drop-shadow-[0_6px_24px_rgba(0,0,0,0.5)]"
              />
            </motion.div>

            {/* Text secundar foarte discret */}
            <motion.div {...textAnim} className="mt-6 flex flex-col items-center">
              <span className="text-[11px] font-bold uppercase tracking-[0.42em] text-roty-gold">
                Pizza &amp; Coffee
              </span>
              <span className="mt-2 text-[9px] font-semibold uppercase tracking-[0.5em] text-roty-cream/45">
                Digital Menu
              </span>
            </motion.div>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default SplashScreen;
